import { ApiResponse } from 'apisauce';

import { GatewayResponse } from '~types/gateway';

import { IAuthGateway } from './authBase';
import { TLoginAPIParams, TLoginAPIResponse, TLogoutAPIParams, TLogoutAPIResponse } from '~types/feat/auth';
import UtilFunctions from '~utils/functions';

const { API: { getHeaders } } = UtilFunctions;

export default class AuthGateway extends IAuthGateway {
    async login(params: TLoginAPIParams): GatewayResponse<TLoginAPIResponse> {
        const response: ApiResponse<TLoginAPIResponse> = await this.api.post('/auth/login', params);
        return this.process(response);
    }

    async logout(params: TLogoutAPIParams): GatewayResponse<TLogoutAPIResponse> {
        const { authToken } = params;
        const response: ApiResponse<TLogoutAPIResponse> = await this.api.post('/auth/logout', {}, getHeaders(authToken));
        return this.process(response);
    }
}
